import AddressBook from '@/components/storefront/checkout/AddressBook'

/**
 * Manage the saved delivery addresses used at courier checkout. The book
 * itself (cards, add/edit modal, default handling) is the same component the
 * checkout uses - here it runs without selection.
 */
export default function Addresses() {
  return (
    <div className="mx-auto max-w-xl">
      <h1 className="text-2xl font-semibold">Addresses</h1>
      <p className="mt-1 text-sm text-foreground/60">
        Your delivery addresses for courier orders. The default one is picked automatically at checkout.
      </p>
      <div className="mt-5">
        <AddressBook />
      </div>
    </div>
  )
}
